import { useState } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { NationalProductsDetails } from '@/types/nationalProducts.types';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';

export const PriceLockSwitchCell = ({ row, table, column }: CellContext<NationalProductsDetails, unknown>) => {
  const { original } = row;
  const { priceLock, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<NationalProductsDetails>;
  const [checked, setChecked] = useState(priceLock);

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked(saveIsLock);
    updateData(row.index, column.id, saveIsLock);
  };

  return <Switch color="error" title="switch" checked={checked} onClick={() => handleClick()} {...rest} />;
};

export const MandatoryLockSwitchCell = ({ row, table, column }: CellContext<NationalProductsDetails, unknown>) => {
  const { original } = row;
  const { mandatoryProductLock, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<NationalProductsDetails>;
  const [checked, setChecked] = useState(mandatoryProductLock);

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked(saveIsLock);
    updateData(row.index, column.id, saveIsLock);
  };

  return <Switch color="error" title="switch" checked={checked} onClick={() => handleClick()} {...rest} />;
};
